import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VToolbar } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"ma-3",attrs:{"elevation":"2","width":"200","height":"200"}},[_c(VToolbar,{attrs:{"dense":"","elevation":"0"}},[_c(VSkeletonLoader,{attrs:{"type":"heading","width":"100%"}})],1),_vm._v(" "),_c(VCardText,[_c(VSkeletonLoader,{staticClass:"mx-auto",attrs:{"type":"image","width":"110","height":"110"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }